import { Component, Prop } from 'vue-property-decorator';
import AgendaViewModel from './agenda.viewmodel';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';
import { TYPE_APPOINTMENT_COLOR, TYPE_EVENT_COLOR } from '../../../../common/constants';
import { namespace } from 'vuex-class';
// @ts-ignore
import { TICKET_MODULE_NAMESPACE } from '@/store/ticket';
import { TICKET_GET_TICKETS, TICKET_GET_TICKET } from '../../../../store/ticket';
import { SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST, SEARCH_REQUEST_BYKEYS, SEARCH_REQUEST_BYKEYS_FORCE, SEARCH_AUTOCOMPLETE } from '../../../../store/search';
import * as moment from 'moment';
import { isNullOrUndefined } from 'util';
import { Moment } from 'moment';
import { AppointmentTypes, TicketTypes, StateTypes, SearchEntities } from '../../../../common/enums';
import { ITicketParameter, TicketParameter } from '../../../../models/ticket';

const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)

@Component
class AgendaModal extends AgendaViewModel {

  [x: string]: any;
  private _clearTimeout: any
  @TicketStore.Action(TICKET_GET_TICKETS)
  storeGetTickets: (payload: { param: any, merge?: boolean }) => Promise<any>;

  @TicketStore.Action(TICKET_GET_TICKET)
  storeGetTicket: (action: { ticketId: number, isTicketModule: boolean }) => Promise<any>;

  @SearchStore.Action(SEARCH_REQUEST)
  storeRequestSearch: () => void;
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetWelcoming: (payload: { entity: SearchEntities, query: string, limit?: number }) => Promise<any>;

  @TicketStore.Getter tickets: any;
  @SearchStore.Getter contractors: any[]
  @SearchStore.Getter declarants: any[]

  private dtStep: number;
  private dtWelcomings: any[]
  private dtIndependentContractors: any[]
  private dtParticipants: any[]
  private dtGetTicketsLoading: boolean;
  private dtTicketParameter: ITicketParameter;
  private dtTickets: any[];
  private dtWelcomingResources: any[];
  dtDefaultText: string;
  dtDateTime: { startDate: string | Date | Moment, endDate: string | Date | Moment }
  dtRules: { nameRules?: any, blockRules?: any, ticketRules?: any, independentContractorRules?: any }
  /**
   *
   */

  @Prop({ default: true, type: [Boolean] })
  self: boolean;
  @Prop({ default: () => [], type: [Array] })
  contractorsSource: any[];

  constructor() {
    super();
    this.dtDefaultText = '';
    this.dtWelcomingResources = null;
    this.dtGetTicketsLoading = false;
    this.dtTicketParameter = new TicketParameter({
      $skip: 0, $limit: 1000, key: null,
      state: [StateTypes.InProgress, StateTypes.Open, StateTypes.ReOpen]
    })
    this.dtRules = {};
    this.dtTickets = []
    this.dtDateTime = {
      startDate: moment().utc().format(),
      endDate: moment().add('m', 30).utc().format()
    }
    this.dtStep = 15;
    this.dtWelcomings = [];
    this.dtIndependentContractors = [];
    this.dtIndependentContractorResources = this.contractorsSource;
    this.dtParticipants = [];
    this.dtRequireTicket = false;
    this._clearTimeout = null;
    this.dtTickets = [];
  }


  get coDeclarants() {
    if (this.declarants && this.declarants.length > 0) {
      this.dtWelcomings = this.appointment.welcomings || [];
    }
    if (this.isUpdating && this.declarants) {
      return [...this.declarants, ...this.originUpdatingAppointment.welcomings];
    }
    return this.declarants || [];
  }
  get redirectToTicket() {
    return {
      to: '/ticket',
      query: {
        contactors: this.dtIndependentContractors.join(',')
      }
    }
  }
  get coTicket() {
    return this.tickets;
  }
  get dateFormat(): string {
    return DateTimeHelper.dateTimeFormat;
  }
  get lblSetting() {
    return {
      ...require('../../../../locales/agenda').default,
      ...require('../../../../locales/generic-labels').default,
      ...require('../../../../locales/validation-messages').default,
    }
  }
  get coIsAppointment(): boolean {
    return this.typeAppointment === this.appointmentType;
  }

  get coWelcomings() { return this.dtWelcomings }
  set coWelcomings(value) {
    this.dtWelcomings = value;
    this.appointmentWelcomings = value;
  }
  get coIndependentContractors() { return this.dtIndependentContractors }
  set coIndependentContractors(value) {
    this.dtIndependentContractors = value;
    this.appointmentIndependentContractors = value;
  }
  get coParticipants() { return this.dtParticipants }
  set coParticipants(value) {
    this.dtParticipants = value;
    this.appointmentParticipants = value;
  }
  get coDates() {
    return {
      startDate: this.appointmentStartDate,
      endDate: this.appointmentEndDate
    }
  }
  set coDates(dates: { startDate: string | Date | Moment, endDate: string | Date | Moment }) {
    this.appointmentStartDate = dates.startDate.toString();
    this.appointmentEndDate = dates.endDate.toString();
  }
  get isUpdating(): boolean {
    return this.appointment.id > 0;
  }
  get coTickets() {
    return (this.tickets || []).concat(this.dtTickets).filter(x => x.state !== StateTypes.Close);;
  }
  get canAddIC(): boolean {
    return !this.$route.meta.select_ic && this.$route.path.indexOf('agenda') > -1;
  }
  getStyleForAppointmentTypeButton(type: string) {
    console.log('type=', type)
    if (this.appointmentType === type)
      return { color: '#FFF' };
    return { color: '#2e038c' }
  }
  handleGetColorByType(type: string) {
    return type === this.typeAppointment ? TYPE_APPOINTMENT_COLOR : TYPE_EVENT_COLOR
  }
  handleChangeType(type: string) {
    if (this.appointmentType !== type)
      this.appointmentType = type;
  }
  handleRedirectToTicket() {
    if (isNullOrUndefined(this.appointmentFkTicket)) {
      this.dtRequireTicket = true;
      setTimeout(() => {
        this.dtRequireTicket = false;
      }, 2000);
      return;
    }
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      let ticketId: number;
      if (this.appointmentFkTicket['id']) {
        ticketId = this.appointmentFkTicket['id']
      } else {
        ticketId = this.appointmentFkTicket;
      }
      this.$router.push({
        path: '/ticket/' + ticketId, query: {
          modal: 'mandate',
          contractors: (this.dtIndependentContractors || []).join(',')
        }
      })
    }, 300);
  }

  handleTicketChange(ticket) {
    if (ticket) {
      this.dtIndependentContractorResources = ticket.independents_contractors_mandate;
      this.coIndependentContractors = this.dtIndependentContractorResources.map(x => x.id);
    }
  }

  created() {

    if (this.isUpdating) {
      this.dtGetTicketsLoading = true;
      if (this.appointment.type === AppointmentTypes.Appointment) {
        this.dtTickets = [];
        this.storeGetTicket({ ticketId: this.appointment.fk_ticket, isTicketModule: false })
          .then(ticket => {
            this.dtGetTicketsLoading = false;
            const isExisted = this.coTickets.filter(x => x.id === ticket.id);
            this.dtDefaultText = ticket.subject;
            if (isExisted.length === 0)
              (this.dtTickets).push(ticket);
            this.dtIndependentContractorResources = ticket.independents_contractors_mandate || [];
          })
          .catch(error => {
            this.dtGetTicketsLoading = false;
            console.log(error, 'error')
          })
      }
    } else {
      this.dtGetTicketsLoading = true;
      this.handleGetTickets();
    }
    this.storeRequestSearch();
    console.log(this.self)
    if (!this.self) {
      const ticketId: number = parseInt(this.$route.params.id);
      if (isNaN(ticketId)) {
        console.error('ticketId is invalid', ticketId);
      }

      let startDate: Date = new Date();
      let ratio = (Math.ceil(startDate.getMinutes() / 60) / 0.25);
      let startTimeInMin: number = (ratio * this.dtStep) - startDate.getMinutes();


      this.storeGetAppointmentById({
        appointment: {
          start_date: moment().utc().add('m', startTimeInMin).format(),
          end_date: moment().utc().add('m', this.dtStep + startTimeInMin).format(),
          type: 'appointment',
          fk_ticket: ticketId
        }
      })
    }
  }
  handleGetTickets(param?: ITicketParameter, cb?: Function) {
    this.dtGetTicketsLoading = true;

    this.storeGetTickets({ param: Object.assign(this.dtTicketParameter, param), merge: false })
      .then(response => {
        this.dtGetTicketsLoading = false;
        if (cb) cb(response);
      })
      .catch(error => {
        this.dtGetTicketsLoading = false;
      });
  }

  get isValidDatetime() {
    const startDate = new Date(this.appointmentStartDate);
    const endDate = new Date(this.appointmentEndDate);
    return startDate < endDate;
  }

  get canCreateAppointment(): boolean {
    if (this.$route.meta.add_appointment && !this.$route.meta.create_event)
      this.storeAssignValueForAppointment({ type: AppointmentTypes.Appointment })
    return !this.$route.meta.add_appointment;
  }
  get canCreateEvent(): boolean {
    if (this.$route.meta.create_event && !this.$route.meta.add_appointment)
      this.storeAssignValueForAppointment({ type: AppointmentTypes.Event })
    return !this.$route.meta.create_event;
  }
  handleSearchWelcoming(query: string) {
    return this.storeGetWelcoming({ entity: SearchEntities.Declarant, query, limit: 50 })
  }
  handeGetTicketsAutocomplete(query: string, cb: Function) {
    this.handleGetTickets({ key: query }, (res) => cb(res))
  }
  mounted() {
    this.dtIndependentContractors = this.appointment.independent_contractors;
    this.dtRules = {
      nameRules: [(v) => !!v || this.$t(this.lblSetting.emptyRequired, {
        type: this.$t(this.lblSetting.genericName)
      })],
      blockRules: [(v) => !!v || this.$t(this.lblSetting.emptyRequired, {
        type: 'Block'
      })],
      ticketRules: [(v) => (!!v && (v > 0 || v.id > 0)) || this.$t(this.lblSetting.emptyRequired, {
        type: 'Ticket'
      })],
      independentContractorRules: [(v) => v.length > 0 || this.$t(this.lblSetting.emptyRequired, {
        type: this.$tc(this.lblSetting.agendaIndependentContractor, 2)
      })]
    }
  }
}

export default AgendaModal;



// WEBPACK FOOTER //
// ./src/containers/agenda/components/agenda-modal/index.ts